module.exports = __webpack_public_path__ + "img/FastForward.929216ac.png";